import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, TextField, InputAdornment, IconButton } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LoginTheme from './LoginTheme';
import styles from './LoginPage.module.css';
import { authClient } from '../../../lib/authClient';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const isValid = password.length >= 8 && password === confirm;

  const handleSubmit = async () => {
    if (!isValid) return;
    setLoading(true);
    setError('');
    const { error } = await authClient.resetPassword({ token, newPassword: password });
    setLoading(false);
    if (error) {
      setError('Der Link ist ungültig oder abgelaufen. Bitte einen neuen Link anfordern.');
    } else {
      setDone(true);
      setTimeout(() => navigate('/intern'), 2000);
    }
  };

  return (
    <div className={styles.welcomePageContainer}>
      <div className={styles.box}>
        <h1>Passwort setzen</h1>
        {done ? (
          <p>Passwort erfolgreich gesetzt. Du wirst weitergeleitet…</p>
        ) : (
          <div className={styles.loginContainer}>
            <ThemeProvider theme={LoginTheme}>
              <TextField
                fullWidth
                margin="normal"
                type={showPassword ? 'text' : 'password'}
                label="Neues Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                helperText="Mindestens 8 Zeichen"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                margin="normal"
                type="password"
                label="Passwort bestätigen"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                error={confirm.length > 0 && password !== confirm}
                helperText={confirm.length > 0 && password !== confirm ? 'Passwörter stimmen nicht überein' : ''}
              />
              {error && <p style={{ color: 'red', fontSize: '0.9em' }}>{error}</p>}
              <Button
                className={styles.loginButton}
                onClick={handleSubmit}
                disabled={!isValid || loading}
              >
                {loading ? 'Wird gesetzt…' : 'Passwort setzen'}
              </Button>
            </ThemeProvider>
          </div>
        )}
      </div>
    </div>
  );
}
